import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {SellerMappersFactory} from '../Mappers/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class GetInstantOfferSellerUseCase extends UseCase {
  #getCurrentUserService
  #httpRepository
  #localStorageRepository
  #rawParamsToGetInstantOfferRequestMapper

  static create({config}) {
    return new GetInstantOfferSellerUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      httpRepository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config}),
      rawParamsToGetInstantOfferRequestMapper: SellerMappersFactory.rawParamsToGetInstantOfferRequestSellerMapper({
        config
      })
    })
  }

  constructor({
    getCurrentUserService,
    httpRepository,
    localStorageRepository,
    rawParamsToGetInstantOfferRequestMapper
  }) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#httpRepository = httpRepository
    this.#localStorageRepository = localStorageRepository
    this.#rawParamsToGetInstantOfferRequestMapper = rawParamsToGetInstantOfferRequestMapper
  }

  @tracer({metric: 'GetInstantOfferSellerUseCase#execute'})
  @AsyncInlineError()
  async execute({
    bodyTypeDoors,
    email,
    fuelId,
    km,
    makeId,
    makeName,
    modelId,
    modelName,
    name,
    phone,
    plate,
    postalCode,
    transmissionTypeId,
    vehicleStatus,
    versionId,
    versionName,
    year
  } = {}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const userId = userEntity ? userEntity.getId() : undefined

    const getInstantOfferRequest = this.#rawParamsToGetInstantOfferRequestMapper.map({
      bodyTypeDoors,
      email,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      name,
      plate,
      phone,
      postalCode,
      transmissionTypeId,
      vehicleStatus,
      versionId,
      versionName,
      year
    })

    const [error, instantOfferEntity] = await this.#httpRepository.getInstantOffer({
      getInstantOfferRequest,
      userId
    })

    if (error) return Promise.reject(error)

    const contactDetails = {name, email, phone}

    await this.#localStorageRepository.saveInstantOfferDetails({
      instantOfferEntity,
      contactDetails
    })

    return {
      ...instantOfferEntity.toJSON(),
      contactDetails
    }
  }
}

export const factory = GetInstantOfferSellerUseCase.create
